import React from "react";
import { Link } from "react-router-dom";

import { portfolioSrc, portfolioSrcSet } from "../lib/images";

const ProjectSpotlight = ({ project, index = 0 }) => {
  if (!project) return null;

  const img = project.coverImage || project.image;
  const imageUrl = portfolioSrc(img);
  // Diagram covers (SVG) are composed edge to edge — cropping them destroys the artwork.
  const isDiagram = Boolean(img && /\.svg$/i.test(img));
  // The card leads with what the project does in the world (cardMetrics); the
  // build numbers stay on the case study page. Three metrics and four tags is
  // the most the card carries before it reads as a spec sheet.
  const cardMetrics = Array.isArray(project.cardMetrics) && project.cardMetrics.length
    ? project.cardMetrics
    : project.metrics;
  const metrics = Array.isArray(cardMetrics) ? cardMetrics.slice(0, 3) : [];
  const stack = Array.isArray(project.stack) ? project.stack : [];
  const visibleStack = stack.slice(0, 4);
  const extraStack = stack.length - visibleStack.length;

  return (
    <article
      className={`project-spotlight${index % 2 === 1 ? " project-spotlight--reverse" : ""}`}
    >
      {imageUrl ? (
        <div
          className={`project-spotlight-media${
            isDiagram ? " project-spotlight-media--contain" : ""
          }`}
        >
          <img
            src={imageUrl}
            srcSet={portfolioSrcSet(img)}
            sizes="(min-width: 900px) 50vw, 92vw"
            alt={`${project.title}, ${project.category || "project"}`}
            loading="lazy"
            decoding="async"
          />
        </div>
      ) : null}

      <div className="project-spotlight-body">
        <div className="project-spotlight-top">
          {project.category ? (
            <span className="project-spotlight-eyebrow">{project.category}</span>
          ) : null}
          <h3 className="project-spotlight-title">{project.title}</h3>
        </div>

        {project.cardSummary ? (
          <p className="project-spotlight-summary">{project.cardSummary}</p>
        ) : null}

        {metrics.length > 0 ? (
          <dl className="project-spotlight-metrics">
            {metrics.map((m) => (
              <div className="project-spotlight-metric" key={m.label}>
                <dt className="project-spotlight-metric-value">{m.value}</dt>
                <dd className="project-spotlight-metric-label">{m.label}</dd>
              </div>
            ))}
          </dl>
        ) : null}

        {visibleStack.length > 0 ? (
          <div className="project-spotlight-tags">
            {visibleStack.map((t) => (
              <span className="project-pill" key={t}>
                {t}
              </span>
            ))}
            {extraStack > 0 ? (
              <span className="project-pill project-pill--muted">
                +{extraStack}
              </span>
            ) : null}
          </div>
        ) : null}

        <div className="project-spotlight-ctas">
          {project.slug ? (
            <Link
              className="project-spotlight-cta"
              to={`/projects/${project.slug}`}
            >
              Read the case study →
            </Link>
          ) : null}
          {project.url ? (
            <a
              className="project-spotlight-cta project-spotlight-cta--secondary"
              href={project.url}
              target="_blank"
              rel="noreferrer"
            >
              Visit {project.url.replace(/^https?:\/\/(www\.)?/, "").replace(/\/$/, "")} ↗
            </a>
          ) : null}
        </div>
      </div>
    </article>
  );
};

export default ProjectSpotlight;
